import { useState } from 'react';
import getWageString from 'wwg-utilities/dist/sharedFunctions/getWageString';
import { isSkillup, isWhereWeGo } from '../../../lib/config/project/project';
import { useAuth } from '../../../lib/providers/authProvider';
import { useRegion } from '../../../lib/providers/regionProvider';
import ShowSalariesInMyRegionButton from '../ShowSalariesInMyRegionButton';

interface WageDataProps {
  customizeWageData?: boolean;
  entryAnnualSalary: number;
  entryHourlyWage: number;
  medianAnnualSalary: number;
  medianHourlyWage: number;
  highAnnualSalary: number;
  highHourlyWage: number;
  textColorClass: string;
  borderRadiusClass: string;
  region: string;
}

const WageData: React.FC<WageDataProps> = ({
  entryAnnualSalary,
  entryHourlyWage,
  medianAnnualSalary,
  medianHourlyWage,
  highAnnualSalary,
  highHourlyWage,
  textColorClass,
  borderRadiusClass,
}) => {
  const { seeker, user } = useAuth();
  const [_salaryLocation, _setSalaryLocation] = useState();

  const { region: fullRegion } = useRegion();

  return (
    <>
      <section className={`bg-white p-1 md:p-4 my-6 ${borderRadiusClass}`}>
        <section className="grid grid-cols-4 ml-5 md:grid-rows-3">
          {isSkillup && (
            <p className="col-start-1 col-end-5 row-start-1 row-end-2 py-2 text-xs md:py-0 md:col-end-2">
              Showing wage data for:{' '}
              <strong>
                {(seeker as any)?.zipcodeLocation || fullRegion.location}
              </strong>
            </p>
          )}
          {isWhereWeGo && (
            <p className="col-start-1 col-end-2 row-start-1 row-end-2 text-xs">
              Showing wage data for: <strong>New Orleans</strong>
            </p>
          )}
          <p className="self-center col-start-2 col-end-3 row-start-2 row-end-3 py-1 text-sm font-bold text-center xl:text-lg md:row-start-1 md:row-end-2">
            Entry
          </p>
          <p className="self-center col-start-3 col-end-4 row-start-2 row-end-2 py-1 text-sm font-bold text-center xl:text-lg md:row-start-1 md:row-end-2">
            Median
          </p>
          <p className="self-center col-start-4 col-end-5 row-start-2 row-end-3 py-1 text-sm font-bold text-center xl:text-lg md:row-start-1 md:row-end-1">
            High
          </p>
          <p className="justify-between col-start-1 col-end-5 row-start-2 row-end-2 border-dashed md:row-start-1 border-b-1 border-md-gray"></p>
          <p className="self-center col-start-1 row-start-3 row-end-4 py-1 text-sm font-bold xl:text-lg md:row-start-2 md:row-end-2">
            Salary
          </p>
          <p className="self-center col-start-1 row-start-4 row-end-5 py-1 text-sm font-bold xl:text-lg md:row-start-3 md:row-end-3">
            Hourly Wage
          </p>
          <p
            className={`${textColorClass} self-center py-1 font-bold text-center text-sm xl:text-lg  row-start-3 row-end-4 md:row-start-2 md:row-end-3 col-start-2`}
          >
            {getWageString({ areaName: '', value: entryAnnualSalary })}
          </p>

          <p
            className={`${textColorClass} self-center py-1 font-bold text-center text-sm xl:text-lg  row-start-3 row-end-4 md:row-start-2 md:row-end-2 col-start-3`}
          >
            {getWageString({ areaName: '', value: medianAnnualSalary })}
          </p>
          <p
            className={`${textColorClass} self-center py-1 font-bold text-center text-sm xl:text-lg  row-start-3 row-end-4 md:row-start-2 md:row-end-2 col-start-4`}
          >
            {getWageString({ areaName: '', value: highAnnualSalary })}
          </p>
          <p
            className={`${textColorClass} self-center py-1 font-bold text-center text-sm xl:text-lg  row-start-4 row-end-5 md:row-start-3 md:row-end-3 col-start-2`}
          >
            {getWageString({ areaName: '', value: entryHourlyWage })}
          </p>
          <p
            className={`${textColorClass} self-center py-1 font-bold text-center text-sm xl:text-lg  row-start-4 row-end-5 md:row-start-3 md:row-end-3 col-start-3`}
          >
            {getWageString({ areaName: '', value: medianHourlyWage })}
          </p>
          <p
            className={`${textColorClass} self-center py-1 font-bold text-center text-sm xl:text-lg  row-start-4 row-end-5 md:row-start-3 md:row-end-3 col-start-4`}
          >
            {getWageString({ areaName: '', value: highHourlyWage })}
          </p>
          {isSkillup && (
            <>{Boolean(!seeker && !user) && <ShowSalariesInMyRegionButton />}</>
          )}
        </section>
      </section>
    </>
  );
};

export default WageData;
